var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_vm._t("bot-avatar"),_c('div',{staticClass:"content",class:{ 'my-message': _vm.isMyMessage }},[_c('MButton',[_vm._v(_vm._s(_vm.message.displayName))])],1),_vm._t("sender-avatar")],2)}
var staticRenderFns = []

export { render, staticRenderFns }